export default String.raw`
.wishlist-popup {
    width: 520px;
    max-height: 468px;
    height: 100%;

    .dialog {
        &__content {
            padding: 24px 32px 32px 32px;
            flex: 1 1 auto;
            overflow: hidden;
            gap: 16px;

            &:has(.add-new-wishlist-target-js:not(.hidden-js)) {
                .add-new-wishlist-js {
                    color: #959595;
                    cursor: default;

                    svg {
                        fill: #959595;
                    }
                }
            }
        }

        &__actions {
            padding: 24px;
            gap: 24px;
        }
    }

    &__section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    &__list {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        min-height: 65px;
        overflow: auto;
        padding: 4px 0;

        &-item {
            display: flex;
            align-items: center;
            gap: 8px;

            &:first-child {
                display: flex;
                gap: 7px;
                width: calc(100% - 16px);

                .form__input-wrapper {
                    margin-bottom: 0;
                }
            }

            input[type="radio"] {
                &:focus-visible {
                    outline-offset: -1px !important;
                }
            }

            input[type="text"] {
                &:focus-visible {
                    outline-offset: 1px !important;
                }
            }
        }
    }

    &__radio {
        padding: 0;
        margin: 0;
        accent-color: #934346;
    }

    &__label {
        @include body-1-regular;
    }
}
`